import { render, staticRenderFns } from "./PsotEditAppr.vue?vue&type=template&id=8604f1c6&scoped=true&"
import script from "./PsotEditAppr.vue?vue&type=script&lang=js&"
export * from "./PsotEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8604f1c6",
  null
  
)

export default component.exports